// Homepage content-block library + types.
// Each block has a `type` and a `data` payload. Renderer reads these on the public Home page.

export const BLOCK_TYPES = {
    heading: {
        label: "Section heading",
        defaults: { eyebrow: "Section", title: "Your heading", subtitle: "" },
        icon: "Type",
    },
    text: {
        label: "Text block",
        defaults: { title: "", body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
        icon: "AlignLeft",
    },
    image_text: {
        label: "Image + text",
        defaults: { title: "Heading", body: "Short description.", image_url: "", layout: "image-left" },
        icon: "Image",
    },
    quote: {
        label: "Pull quote",
        defaults: { quote: "A short, powerful quote.", attribution: "Source / Name", role: "" },
        icon: "Quote",
    },
    stats: {
        label: "Stats strip",
        defaults: { eyebrow: "Our impact", stats: [{ value: "10K+", label: "Lives reached" }, { value: "14", label: "Programs" }, { value: "8", label: "States" }] },
        icon: "BarChart3",
    },
    cta: {
        label: "Call to action",
        defaults: { eyebrow: "Get involved", title: "Walk with us.", body: "Donors, peers, government partners — we'd love to hear from you.", button_label: "Get in touch", button_link: "/contact" },
        icon: "ArrowRight",
    },
    spacer: {
        label: "Spacer",
        defaults: { size: 80 },
        icon: "MoreHorizontal",
    },
};

export const newBlock = (type) => {
    const meta = BLOCK_TYPES[type];
    if (!meta) return null;
    return {
        id: (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${type}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        type,
        data: JSON.parse(JSON.stringify(meta.defaults)),
    };
};

export const duplicateBlock = (block) => ({
    ...JSON.parse(JSON.stringify(block)),
    id: (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${block.type}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
});
